import { http, HttpResponse, HttpHandler } from 'msw';

import { Option } from '../../../domain/reference-data';

const businessTypes = [
  'Corporation',
  'Limited Liability Company (LLC)',
  'Limited Liability Partnership (LLP)',
  'Nonprofit',
  'Other Partnership',
  'Sole Proprietorship',
];

const industries = [
  {
    id: 'residential_commercial',
    name: 'Residential and Commercial Services (Roofing, Painting, Electrical, HVAC, Plumbing, Pool, Pest Control)',
  },
  { id: 'over_the_road', name: 'Trucking - Over the Road' },
  { id: 'trucking_local', name: 'Trucking - Local' },
  { id: 'auto_repair', name: 'Auto Repair' },
  { id: 'car_dealerships', name: 'Car Dealerships' },
  { id: 'cleaning_services', name: 'Cleaning services' },
  { id: 'construction', name: 'Construction' },
  { id: 'government', name: 'Government' },
  { id: 'health_services', name: 'Health Services' },
  { id: 'import_export_companies', name: 'Import/export companies' },
  { id: 'landscaping', name: 'Landscaping' },
  { id: 'limo_and_taxi_services', name: 'Limo and Taxi Services' },
  { id: 'manufacturing_and_industrial', name: 'Manufacturing and Industrial' },
  { id: 'mining', name: 'Mining' },
  { id: 'oil_and_gas', name: 'Oil and Gas' },
  { id: 'property_managers', name: 'Property Managers' },
  { id: 'moving_company', name: 'Moving Company' },
  { id: 'restaurant_or_food_delivery', name: 'Restaurant or Food Delivery' },
  { id: 'retail', name: 'Retail' },
  { id: 'security', name: 'Security' },
  { id: 'telecommunications', name: 'Telecommunications' },
  { id: 'towing', name: 'Towing' },
  { id: 'utilities', name: 'Utilities' },
  { id: 'other', name: 'Other' },
];

const states = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'CA', name: 'California' },
  { code: 'ME', name: 'Maine' },
  { code: 'NY', name: 'New York' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'WA', name: 'Washington' },
];

const handlers: HttpHandler[] = [
  http.get<never, never, string[]>('/qualification/ref_data/business_types', () => {
    return HttpResponse.json(businessTypes);
  }),

  http.get<never, never, Option[]>('/qualification/ref_data/industries', () => {
    return HttpResponse.json(industries);
  }),

  http.get<never, never, Array<{ code: string; name: string }>>('/qualification/ref_data/states', () => {
    return HttpResponse.json(states);
  }),
];

export { handlers };
